/* eslint-disable no-param-reassign */

import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeModalId: '',
    birthDate: {
      isValid: () => false,
    },
    currentDate: null,
    currentSection: 0,
    sectionsCount: 0,
    selectedFutureOccasions: [],
  },
  getters: {
    isBirthDateValid: state => state.birthDate.isValid(),
    isFirstSection: state => state.currentSection === 0,
    isLastSection: state => state.currentSection === state.sectionsCount - 1,
  },
  actions: {
    changeSectionBack({ commit, getters, state }) {
      if (!state.activeModalId && !getters.isFirstSection) {
        commit('setCurrentSection', state.currentSection - 1)
      }
    },
    changeSectionForward({ commit, getters, state }) {
      if (!state.activeModalId && !getters.isLastSection && getters.isBirthDateValid) {
        commit('setCurrentSection', state.currentSection + 1)
      }
    },
    closeModal({ commit }) {
      commit('setActiveModalId', '')
    },
    goToSection({ commit, getters }, index) {
      if (getters.isBirthDateValid) {
        commit('setCurrentSection', index)
      }
    },
    openModal({ commit }, modalId) {
      commit('setActiveModalId', modalId)
    },
    runCurrentDateUpdater({ commit }) {
      commit('setCurrentDate')
    },
    setBirthDate({ commit }, value) {
      commit('setBirthDate', value)
    },
    setSelectedFutureOccasions({ commit }, list) {
      commit('setSelectedFutureOccasions', list)
    },
  },
  mutations: {
    setActiveModalId(state, id) {
      state.activeModalId = id
    },
    setBirthDate(state, momentObject) {
      state.birthDate = momentObject
    },
    setCurrentDate(state) {
      state.currentDate = moment()

      setInterval(() => {
        state.currentDate = moment()
      }, 1000)
    },
    setCurrentSection(state, value) {
      state.currentSection = value
    },
    setSectionsCount(state, value) {
      state.sectionsCount = value
    },
    setSelectedFutureOccasions(state, list) {
      state.selectedFutureOccasions = list
    },
  },
})
